import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  isEmptyVal,
  isNotEmpty,
  displayField,
  displayDateTimeField,
  displayDateField,
} from "../../../utils/helpers";

const CommercialScheduleInfoCell = ({
  dataKey,
  rowData,
  onClick,
  ...props
}: {
  dataKey?: string;
  rowData: any;
  onClick?: Function;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  if (isEmptyVal(rowData?.total_items)) rowData.total_items = 0;
  const speaker = (
    <Popover title={rowData?.schedule_title}>
      <p>
        <b>{t("NAME")} : </b>
        {displayField(rowData.schedule_title)}
      </p>
      <p>
        <b>{t("ITEMS")} : </b>
        {displayField(rowData?.total_items)} {t("OUT_OF")}{" "}
        {displayField(parseInt(rowData?.max_items))}
      </p>
      <p>
        <b>
          {t("NEW")} {t("SCHEDULE")} {t("EVERYDAY")} :{" "}
        </b>
        {rowData?.new_schedule_everyday.toString() === "1" ? t("YES") : t("NO")}
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a
          onClick={() => {
            onClick && onClick(rowData);
          }}
        >
          {displayField(rowData.schedule_title)} <br />
          {rowData.total_items} {t("ITEMS")}
          <br />
          {!isEmptyVal(rowData?.schedule_date_from) &&
            " " +
              displayDateField(rowData?.schedule_date_from) +
              " " +
              t("TO") +
              " " +
              displayDateField(rowData?.schedule_date_to)}
        </a>
      </Whisper>
    </Cell>
  );
};

export default CommercialScheduleInfoCell;
